import React, { useState, useEffect } from "react";

import {
  Paper,
  TableRow,
  TableCell,
} from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  ModalDeleteConfirm,
  Title,
  Loading,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import { useDatatablesServerSide, useDatatables } from "App/hooks";
import {
  deletePoById,
  getByFilterReq,
  headCells,
  RenderStatusKebutuhanBadge,
  RenderStatusVerifikasiBadge,
  RESET_STATE_FORM_FILTER,
} from "./helpers";
import { PencilIcon, SelectIcon, TrashIcon } from "App/Assets";
import {
  defaultDateDisplay,
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";

import { WMS_FA_PENGAJUAN } from "App/constants";
import {
  STATUS_TRANSAKSI_DRAFT,
  STATUS_TRANSAKSI_PENGADAAN,
  STATUS_TRANSAKSI_REVISI,
} from "../RequestFixedAsset/helpers";
import FormFilterDaftarRequest from "./FormFilterDaftarREQ";
import { FreezeTable } from "components/organism";

export default function PengajuanRequest({
  changeTitle,
  changeParentData,
  changeMenu,
  handleClickMenu,
}) {
  const classes = STYLE_DEFAULT_MASTER();
  const [reqID, setReqID] = useState(null);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const handleClickUpdate = async (row) => {
    Promise.resolve()
      .then(() => {
        changeMenu(WMS_FA_PENGAJUAN);
      })
      .then(() => {
        changeParentData({
          idreq: row?.id,
          nama: row?.name,
          unit_id: row?.unit_id,
          unit: row?.unit,
          status_kebutuhan: row?.status_kebutuhan,
          status_kebutuhan_nama:
            row?.status_kebutuhan === 1
              ? "Normal"
              : row?.status_kebutuhan === 2
              ? "Medium"
              : row?.status_kebutuhan === 3
              ? "Urgent"
              : "Tidak Ditemukan",
          remark: row?.remark,
          remak_verifikasi: row?.remak_verifikasi,
          status_verifikasi: row?.status_verifikasi,
          user_request: row?.user_request,
          type: "update",
          status: true,
          isOpenDraf:
            row?.status_verifikasi === STATUS_TRANSAKSI_DRAFT
              ? true
              : row?.status_verifikasi === STATUS_TRANSAKSI_REVISI
              ? true
              : false,
          isProcess:
            row?.status_verifikasi === STATUS_TRANSAKSI_DRAFT
              ? false
              : row?.status_verifikasi === STATUS_TRANSAKSI_REVISI
              ? false
              : true,
          date: defaultDateInputDisplay(row?.tgl_permintaan),
          listreq: [],
        });
        changeTitle(WMS_FA_PENGAJUAN);
        handleClickMenu({
          code: WMS_FA_PENGAJUAN,
          name: "Input Pengajuan Fixed Asset",
        });
      });
  };

  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getByFilterReq(formFilter, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  const handleClickDelete = (row) => {
    setReqID(row?.id);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  };

  async function deleteList() {
    const res = await deletePoById(reqID);
    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  return (
    <>
      <div className={classes.root}>
        <Title title={"Daftar Pengajuan Request Fixed Asset"} />

        {showModalDeleteConfirm && (
          <ModalDeleteConfirm
            confirmHandle={() => deleteList()}
            setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          />
        )}

        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}
        >
          <FormFilterDaftarRequest
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
          />
          <Loading show={loading} />
          <TableDaftarRequest
            rows={rows}
            classes={classes}
            handleClickDelete={handleClickDelete}
            handleClickUpdate={handleClickUpdate}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </>
  );
}

export const TableDaftarRequest = ({
  rows,
  classes,
  handleClickUpdate,
  handleClickDelete,
  onlySelect = false,
  handleClickSelect,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  const RenderAction = ({ row }) => {
    if (onlySelect) {
      if (row?.status_verifikasi === STATUS_TRANSAKSI_PENGADAAN) {
        return (
          <>
            <IconButtonDatatable
              color="secondary"
              onClick={() => handleClickSelect(row)}
            >
              <SelectIcon width={"14"} height={"14"} fill={"#fff"} />
            </IconButtonDatatable>
          </>
        );
      } else {
        return <></>;
      }
    } else {
      if (row?.status_verifikasi === STATUS_TRANSAKSI_DRAFT) {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "7px",
            }}
          >
            <IconButtonDatatable onClick={() => handleClickUpdate(row)}>
              <PencilIcon />
            </IconButtonDatatable>
            <IconButtonDatatable onClick={() => handleClickDelete(row)}>
              <TrashIcon />
            </IconButtonDatatable>
          </div>
        );
      } else {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "7px",
            }}
          >
            <IconButtonDatatable onClick={() => handleClickUpdate(row)}>
              <PencilIcon />
            </IconButtonDatatable>
          </div>
        );
      }
    }
  };

  return (
    <FreezeTable
      headCells={headCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}
    >
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        return (
          <TableRow
            hover
            tabIndex={-1}
            key={index}
            // style={{
            //   backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
            // }}
          >
            <TableCell scope="row" padding="none" align="center">
              {index + 1}
            </TableCell>

            <TableCell scope="row" padding="none" align="center">
              <RenderAction row={row} />
            </TableCell>
            <TableCell align="left">{row?.id}</TableCell>
            <TableCell align="left">{row?.name}</TableCell>
            <TableCell align="left">{row?.unit}</TableCell>
            <TableCell align="left">
              <RenderStatusKebutuhanBadge status={row.status_kebutuhan} />
            </TableCell>
            <TableCell align="left">{row?.user_request}</TableCell>
            <TableCell align="left">{row.jml_req_barang}</TableCell>
            <TableCell align="left">
              <RenderStatusVerifikasiBadge status={row?.status_verifikasi} />
            </TableCell>
            <TableCell align="left">
              {isNull(row?.remark) ? null : row?.remark}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.tanggal_verifikasi)
                ? "-"
                : defaultDateDisplay(row?.tanggal_verifikasi)}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.user_verifikasi) ? "-" : row?.user_verifikasi}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.remak_verifikasi) ? "-" : row?.remak_verifikasi}
            </TableCell>
            <TableCell align="left">
              {defaultDateDisplay(row?.tgl_permintaan)}
            </TableCell>
            <TableCell align="left">
              {defaultDateDisplay(row?.createdAt)}
            </TableCell>
            <TableCell align="left">{row?.createdBy}</TableCell>
            <TableCell align="left">
              {defaultDateDisplay(row?.updatedAt)}
            </TableCell>
            <TableCell align="left">{row?.updatedBy}</TableCell>
          </TableRow>
        );
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align="center" colSpan={headCells.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  );
};
